/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Deep_P3Inputs */

const en_formatter_deep_p3 = /** @type {(inputs: Formatter_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key order is preserved for ordinary keys, because objects keep insertion order. Keys that look like array indices are the exception: integer-like keys are always visited in ascending numeric order and placed ahead of every string key. An object written as 10, 2, b, a comes back as 2, 10, b, a. This is a property of the object model underneath, not a choice the formatter makes, and every browser based JSON tool behaves the same way.`)
};

const ko_formatter_deep_p3 = /** @type {(inputs: Formatter_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일반적인 키의 순서는 유지됩니다. 객체가 삽입 순서를 기억하기 때문입니다. 배열 인덱스처럼 보이는 키는 예외입니다. 정수형 키는 항상 오름차순으로 방문되며 모든 문자열 키보다 앞에 놓입니다. 10, 2, b, a 순서로 쓴 객체는 2, 10, b, a로 돌아옵니다. 이는 포매터의 선택이 아니라 그 아래 객체 모델의 성질이며, 브라우저 기반 JSON 도구는 모두 같게 동작합니다.`)
};

const ja_formatter_deep_p3 = /** @type {(inputs: Formatter_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通常のキーの順序は保たれます。オブジェクトが挿入順を覚えているからです。配列の添字のように見えるキーは例外です。整数的なキーは常に昇順で走査され、すべての文字列キーより前に置かれます。10, 2, b, a の順で書いたオブジェクトは 2, 10, b, a で返ってきます。これはフォーマッタの選択ではなくその下のオブジェクトモデルの性質で、ブラウザベースの JSON ツールはすべて同じ挙動になります。`)
};

/**
* | output |
* | --- |
* | "Key order is preserved for ordinary keys, because objects keep insertion order. Keys that look like array indices are the exception: integer-like keys are al..." |
*
* @param {Formatter_Deep_P3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_deep_p3 = /** @type {((inputs?: Formatter_Deep_P3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Deep_P3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_deep_p3(inputs)
	if (locale === "ko") return ko_formatter_deep_p3(inputs)
	return ja_formatter_deep_p3(inputs)
});